"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var CashMeIcon_1 = __importDefault(require("../Icons/MortgageButton/CashMeIcon"));
var react_redux_1 = require("react-redux");
var currencySlice_1 = require("../../features/currencies/currencySlice");
var currencyConverter_1 = require("../../helpers/currencyConverter");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var MortgageButton = function (_a) {
    var region = _a.region, address = _a.address, district = _a.district, price = _a.price, _b = _a.isRedirectToCashMe, isRedirectToCashMe = _b === void 0 ? true : _b, onClick = _a.onClick, _c = _a.hasIcon, hasIcon = _c === void 0 ? true : _c;
    var t = react_i18next_1.useTranslation('common').t;
    var hasPrice = !!price.length;
    var all = react_redux_1.useSelector(currencySlice_1.selectAllExchangeRates);
    var currency = react_redux_1.useSelector(currencySlice_1.selectCurrentCurrency);
    var convertedCurrency = hasPrice && currencyConverter_1.convertToCurrency(price, 1, all, currency, false);
    var buttonCashMe = (react_1.default.createElement("div", { className: styles_module_scss_1.default.box },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.left_content },
            react_1.default.createElement("span", null, t('MORTGAGE_BUTTON.TEXT'))),
        hasIcon && (react_1.default.createElement("div", { className: "cash-me-icon" },
            react_1.default.createElement(CashMeIcon_1.default, null)))));
    return isRedirectToCashMe ? (react_1.default.createElement("a", { href: process.env.MIX_CASH_ME_URL +
            ("&type=secondary&price=" + convertedCurrency + "&region=" + region + "&address=" + district + "," + address), target: "_blank", className: styles_module_scss_1.default.mortgage_button, onClick: onClick }, buttonCashMe)) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.mortgage_button, onClick: onClick }, buttonCashMe));
};
exports.default = MortgageButton;
